












import { Vue, Component, Prop } from "@/shared/vuepack";
import { MfaStatusEnum } from "../types";
import { RawLocation } from "vue-router";
import Login from "@/shared/components/Login.vue";
import EmployerPortalOktaLogin from "@/shared/components/EmployerPortalOktaLogin.vue";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    Login,
    EmployerPortalOktaLogin
  }
})
export default class LoginDecider extends Vue {
  userStore = useUserStore();

  @Prop()
  routeToForgotPassword;

  @Prop()
  routeToUpdatePassword: (user: string, password: string) => Location;

  @Prop()
  MfaRouteFunc: (username: string, password: string, mfaStatus: MfaStatusEnum,
                  SetupBiometricAuth: boolean) => RawLocation;

  @Prop()
  routeToBiometricAuthSetup: (user: string, password: string) => Location;

  get showEmployerPortalOktaLogin () {
    return this.userStore.isEmployerPortal;
  }
}
